// import FilterRow, {
//     FilterRowProps,
// } from "../../../components/UtilitiesComponent/FilterRow";
import assest from "../../../json/assest";
// import Image from "next/image";
import React from "react";
import styles from "../../../styles/pages/home.module.scss";
import {
  Box,
  Button,
  Dialog,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import Pagination from "../../../components/UtilitiesComponent/Pagination";
import AllPurchasedFilterModal from "../../../components/FilterModal/AllPurchasedFilterModal";
// import { useRouter } from "next/router";
import DisplayRelease from "../../../components/DisplayRelease/DisplayRelease";
import BuyerWebskiteFilter from "../../../components/AllFilterRow/BuyerPageFilter/BuyerWebskiteFilter";
import styles1 from "../../../styles/components/BuyerPageTable/BuyerAllTable.module.scss";
import {
  concatHostAndImagePath,
  getUtcDate,
  getUtcDateTime,
  getUtcTime,
} from "../../../lib/functions/utils.lib";
import EmptyTable from "../../EmptyTable/EmptyTable";
import Filter from "../../Filter/Filter";
import NoResult from "../../NoResult/NoResult";
import { useAppSelector } from "../../../hooks/useAppSelector";
import ContentBuyerWebsiteOnlyModal from "../../ContentBuyerModal/ContentBuyerWebsiteOnlyModal";
import { Link } from "react-router-dom";
import PerfectScrollbar from "react-perfect-scrollbar";
import VideoPageFullModal from "../../VideoPages/pages/VideoPageFullModal";
import { useState } from "react";
import WatchVideoModal from "../../VideoPages/pages/WatchVideoModal";

function createData(
  VSID,
  Buyer,
  Thumbnail,
  Title,
  Owner,
  Email,
  Purchase,
  Approved
) {
  return { VSID, Buyer, Thumbnail, Title, Owner, Email, Purchase, Approved };
}

/* const rows = [
  createData(
    "13194",
    "John Smith",
    <>
      <img src={assest.tabthumbnail1} width={73} height={46} alt="" />
    </>,
    "Boy Jumped with the Umbrella and the Wind Almost Sent Him Flying Too Far Away",
    "John Smith",
    "johnsmith@gmail.com",
    <>
      September 26, 2019 <br /> at 05:45:23 AM UTC
    </>,
    <strong>
      Ahmed Mamdouh <br /> <span>Manager</span> <br />{" "}
      <strong>Aug 7, 2019 at 04:24:55 PM UTC</strong>
    </>
  ),
  createData(
    "13194",
    "John Smith",
    <>
      <img src={assest.tabthumbnail2} width={73} height={46} alt="" />
    </>,
    "Rabbit on fence",
    "John Smith",
    "johnsmith@gmail.com",
    <>
      September 26, 2019 <br /> at 05:45:23 AM UTC
    </>,
    <strong>
      Ahmed Mamdouh <br /> <span>Manager</span> <br />{" "}
      <strong>Aug 7, 2019 at 04:24:55 PM UTC</strong>
    </>
  ),

  createData(
    "13194",
    "John Smith",
    <>
      <img src={assest.tabthumbnail3} width={73} height={46} alt="" />
    </>,
    "Rabbit on fence",
    "John Smith",
    "johnsmith@gmail.com",
    <>
      September 26, 2019 <br /> at 05:45:23 AM UTC
    </>,
    <strong>
      Ahmed Mamdouh <br /> <span>Manager</span> <br />{" "}
      <strong>Aug 7, 2019 at 04:24:55 PM UTC</strong>
    </>
  ),

  createData(
    "13194",
    "John Smith",
    <>
      <img src={assest.tabthumbnail4} width={73} height={46} alt="" />
    </>,
    "Rabbit on fence",
    "John Smith",
    "johnsmith@gmail.com",
    <>
      September 26, 2019 <br /> at 05:45:23 AM UTC
    </>,
    <strong>
      Ahmed Mamdouh <br /> <span>Manager</span> <br />{" "}
      <strong>Aug 7, 2019 at 04:24:55 PM UTC</strong>
    </>
  ),

  createData(
    "13194",
    "John Smith",
    <>
      <img src={assest.tabthumbnail5} width={73} height={46} alt="" />
    </>,
    "Girl Tries Hitting a Car with Her Hand at a Traffic Light",
    "John Smith",
    "johnsmith@gmail.com",
    <>
      September 26, 2019 <br /> at 05:45:23 AM UTC
    </>,
    <strong>
      Ahmed Mamdouh <br /> <span>Manager</span> <br />{" "}
      <strong>Aug 7, 2019 at 04:24:55 PM UTC</strong>
    </>
  ),

  createData(
    "13194",
    "John Smith",
    <>
      <img src={assest.tabthumbnail6} width={73} height={46} alt="" />
    </>,
    "Girl Gets Surprised with a Baby Yoda Toy That She Wanted for So Long",
    "John Smith",
    "johnsmith@gmail.com",
    <>
      September 26, 2019 <br /> at 05:45:23 AM UTC
    </>,
    <strong>
      Ahmed Mamdouh <br /> <span>Manager</span> <br />{" "}
      <strong>Aug 7, 2019 at 04:24:55 PM UTC</strong>
    </>
  ),

  createData(
    "13194",
    "John Smith",
    <>
      <img src={assest.tabthumbnail7} width={73} height={46} alt="" />
    </>,
    "Rabbit on fence",
    "John Smith",
    "johnsmith@gmail.com",
    <>
      September 26, 2019 <br /> at 05:45:23 AM UTC
    </>,
    <strong>
      Ahmed Mamdouh <br /> <span>Manager</span> <br />{" "}
      <strong>Aug 7, 2019 at 04:24:55 PM UTC</strong>
    </>
  ),

  createData(
    "13194",
    "John Smith",
    <>
      <img src={assest.tabthumbnail8} width={73} height={46} alt="" />
    </>,
    "Rabbit on fence",
    "John Smith",
    "johnsmith@gmail.com",
    <>
      September 26, 2019 <br /> at 05:45:23 AM UTC
    </>,
    <strong>
      Ahmed Mamdouh <br /> <span>Manager</span> <br />{" "}
      <strong>Aug 7, 2019 at 04:24:55 PM UTC</strong>
    </>
  ),

  createData(
    "13194",
    "John Smith",
    <>
      <img src={assest.tabthumbnail9} width={73} height={46} alt="" />
    </>,
    "Rabbit on fence",
    "John Smith",
    "johnsmith@gmail.com",
    <>
      September 26, 2019 <br /> at 05:45:23 AM UTC
    </>,
    <strong>
      Ahmed Mamdouh <br /> <span>Manager</span> <br />{" "}
      <strong>Aug 7, 2019 at 04:24:55 PM UTC</strong>
    </>
  ),

  createData(
    "13194",
    "John Smith",
    <>
      <img src={assest.tabthumbnail10} width={73} height={46} alt="" />
    </>,
    "Boy Jumped with the Umbrella and the Wind Almost Sent Him Flying Too Far Away",
    "John Smith",
    "johnsmith@gmail.com",
    <>
      September 26, 2019 <br /> at 05:45:23 AM UTC
    </>,
    <strong>
      Ahmed Mamdouh <br /> <span>Manager</span> <br />{" "}
      <strong>Aug 7, 2019 at 04:24:55 PM UTC</strong>
    </>
  ),

  createData(
    "13194",
    "John Smith",
    <>
      <img src={assest.tabthumbnail11} width={73} height={46} alt="" />
    </>,
    "Rabbit on fence",
    "John Smith",
    "johnsmith@gmail.com",
    <>
      September 26, 2019 <br /> at 05:45:23 AM UTC
    </>,
    <strong>
      Ahmed Mamdouh <br /> <span>Manager</span> <br />{" "}
      <strong>Aug 7, 2019 at 04:24:55 PM UTC</strong>
    </>
  ),

  createData(
    "13194",
    "John Smith",
    <>
      <img src={assest.tabthumbnail12} width={73} height={46} alt="" />
    </>,
    "Rabbit on fence",
    "John Smith",
    "johnsmith@gmail.com",
    <>
      September 26, 2019 <br /> at 05:45:23 AM UTC
    </>,
    <strong>
      Ahmed Mamdouh <br /> <span>Manager</span> <br />{" "}
      <strong>Aug 7, 2019 at 04:24:55 PM UTC</strong>
    </>
  ),

  createData(
    "13194",
    "John Smith",
    <>
      <img src={assest.tabthumbnail13} width={73} height={46} alt="" />
    </>,
    "Rabbit on fence",
    "John Smith",
    "johnsmith@gmail.com",
    <>
      September 26, 2019 <br /> at 05:45:23 AM UTC
    </>,
    <strong>
      Ahmed Mamdouh <br /> <span>Manager</span> <br />{" "}
      <strong>Aug 7, 2019 at 04:24:55 PM UTC</strong>
    </>
  ),

  createData(
    "13194",
    "John Smith",
    <>
      <img src={assest.tabthumbnail14} width={73} height={46} alt="" />
    </>,
    "Rabbit on fence",
    "John Smith",
    "johnsmith@gmail.com",
    <>
      September 26, 2019 <br /> at 05:45:23 AM UTC
    </>,
    <strong>
      Ahmed Mamdouh <br /> <span>Manager</span> <br />{" "}
      <strong>Aug 7, 2019 at 04:24:55 PM UTC</strong>
    </>
  ),

  createData(
    "13194",
    "John Smith",
    <>
      <img src={assest.tabthumbnail15} width={73} height={46} alt="" />
    </>,
    "Rabbit on fence",
    "John Smith",
    "johnsmith@gmail.com",
    <>
      September 26, 2019 <br /> at 05:45:23 AM UTC
    </>,
    <strong>
      Ahmed Mamdouh <br /> <span>Manager</span> <br />{" "}
      <strong>Aug 7, 2019 at 04:24:55 PM UTC</strong>
    </>
  ),

  createData(
    "13194",
    "John Smith",
    <>
      <img src={assest.tabthumbnail16} width={73} height={46} alt="" />
    </>,
    "Rabbit on fence",
    "John Smith",
    "johnsmith@gmail.com",
    <>
      September 26, 2019 <br /> at 05:45:23 AM UTC
    </>,
    <strong>
      Ahmed Mamdouh <br /> <span>Manager</span> <br />{" "}
      <strong>Aug 7, 2019 at 04:24:55 PM UTC</strong>
    </>
  ),

  createData(
    "13194",
    "John Smith",
    <>
      <img src={assest.tabthumbnail17} width={73} height={46} alt="" />
    </>,
    "Rabbit on fence",
    "John Smith",
    "johnsmith@gmail.com",
    <>
      September 26, 2019 <br /> at 05:45:23 AM UTC
    </>,
    <strong>
      Ahmed Mamdouh <br /> <span>Manager</span> <br />{" "}
      <strong>Aug 7, 2019 at 04:24:55 PM UTC</strong>
    </>
  ),

  createData(
    "13194",
    "John Smith",
    <>
      <img src={assest.tabthumbnail18} width={73} height={46} alt="" />
    </>,
    "Rabbit on fence",
    "John Smith",
    "johnsmith@gmail.com",
    <>
      September 26, 2019 <br /> at 05:45:23 AM UTC
    </>,
    <strong>
      Ahmed Mamdouh <br /> <span>Manager</span> <br />{" "}
      <strong>Aug 7, 2019 at 04:24:55 PM UTC</strong>
    </>
  ),

  createData(
    "13194",
    "John Smith",
    <>
      <img src={assest.tabthumbnail19} width={73} height={46} alt="" />
    </>,
    "Rabbit on fence",
    "John Smith",
    "johnsmith@gmail.com",
    <>
      September 26, 2019 <br /> at 05:45:23 AM UTC
    </>,
    <strong>
      Ahmed Mamdouh <br /> <span>Manager</span> <br />{" "}
      <strong>Aug 7, 2019 at 04:24:55 PM UTC</strong>
    </>
  ),
]; */

// type SingleTableContainerProps = {
//     hideApprovedTab?: boolean;
//     approvedTabName?: string;
//     filterRowProps? ;
// };
export default function BuyerWebsiteTable(props) {
  const {
    hideApprovedTab,
    approvedTabName,
    filterRowProps,
    filterRefetch,
    handleClearFilterModal,
    p,
    handleTriggreFetch,
  } = props;
  // const route = useRouter();

  const {
    month,
    year,
    manager_id,
    published,
    unreachable_submitter,
    from,
    to,
    query,
    pendingData,
    submit_place,
    confirmed,
  } = useAppSelector((s) => s.contentBuyerSlice);
  // for modal

  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = (value) => {
    setOpen(false);
  };

  // for modal
  // modal design

  const [openModal, setOpenModal] = useState(false);
  const [openModalTwo, setOpenModalTwo] = useState(false);
  const [id, setId] = useState();

  const onOpen = (id) => {
    setId(id);
    setOpenModal(true);
  };
  const onClose = () => {
    setId();
    setOpenModal(false);
    handleTriggreFetch();
  };
  const onOpenTwo = (id) => {
    setId(id);
    setOpenModalTwo(true);
  };
  const onCloseTwo = () => {
    setId();
    setOpenModalTwo(false);
  };
  // modal design

  return (
    <Box className={styles.table_sec}>
      <Box className={styles.table_top}>
        <BuyerWebskiteFilter
          {...filterRowProps}
          FilterModalComponent={ContentBuyerWebsiteOnlyModal}
          filterModalProps={{
            hideBottom: true,
            handleFilterParamChange: props?.handleFilterParamChange,
            filterRefetch,
            handleClearFilterModal,
            p,
          }}
          handleTriggreFetch={props?.handleTriggreFetch}
          filtersReset={props?.filtersReset}
        />
      </Box>

      <Box className={`${styles.table_main} ${styles1.tableWebsite}`}>
        {/* <PerfectScrollbar> */}
        <TableContainer component={Paper}>
          <Table stickyHeader aria-label="sticky table">
            <TableHead>
              <TableRow>
                <TableCell className={styles1.vsid}>VSID</TableCell>
                <TableCell className={styles1.thumnail}>Thumbnail</TableCell>
                <TableCell className={styles1.tableTitle}>Title</TableCell>
                <TableCell className={styles1.submitter}>
                  Owner Name
                </TableCell>
                <TableCell className={styles1.email}>Email Address</TableCell>
                <TableCell className={styles1.submission}>
                  Submission Date
                </TableCell>
                <TableCell className={styles1.rejected}>Marked by</TableCell>
                <TableCell className={styles1.view}>View</TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {props?.videos?.data?.length > 0 ? (
                <>
                  {props?.videos?.data?.map((row) => (
                    <>
                      <TableRow
                        key={row.id}
                        sx={{
                          "&:last-child td, &:last-child th": { border: 0 },
                        }}
                      >
                        <TableCell>
                          <Box className={styles.vsid_code}>
                            {/* <img
                            src={assest.infoicon}
                            width={3}
                            height={18}
                            alt=""
                          /> */}{" "}
                            <p>
                              {row.id}{" "}
                              {row.unseen_messages ? (
                          <span className={styles.vsid_circ}></span>
                        ) : (
                          <></>
                        )}
                            </p>
                          </Box>
                        </TableCell>
                        <TableCell>
                          <Button onClick={() => onOpenTwo(row.id)}>
                            <figure className={styles.thumb_img}>
                              <img
                                src={concatHostAndImagePath(row.thumbnail)}
                                width={73}
                                height={46}
                                alt="image"
                                className={styles.thumImg}
                              />
                            </figure>
                          </Button>
                        </TableCell>
                        <TableCell>
                          <Box className={styles.vTitle}> {row?.title}</Box>
                        </TableCell>
                        <TableCell>
                          <Box className={styles.submitterName}>
                            {row?.first_name || row?.last_name
                              ? `${row?.first_name} ${row?.last_name}`
                              : "N/A"}
                          </Box>
                        </TableCell>
                        <TableCell>
                          {row?.email ? row?.email : "N/A"}
                          {row.unreachable_submitter ? (
                            <p className={styles.red_email}>
                              Unreachable Email
                            </p>
                          ) : (
                            <></>
                          )}
                        </TableCell>
                        <TableCell>
                          {getUtcDate(row.created_at)} <br />
                          {getUtcTime(row.created_at)}
                        </TableCell>
                        <TableCell>
                          <Box className={styles.manager}>
                            <>
                              {row?.manager?.name}
                              <br /> <span>Manager</span> <br />
                              <strong>
                                {" "}
                                {row.video_meta.manager_updated_at
                                  ? `${getUtcDateTime(
                                    row.video_meta.manager_updated_at
                                  )}`
                                  : ""}
                              </strong>
                            </>
                            )
                          </Box>
                        </TableCell>
                        <TableCell>
                          {/* <Link
                            to={`/video/${row.id}`}
                            target="_blank"
                            rel="noopener noreferrer"
                          > */}
                          <Box className={styles.table_view}>
                            <Button onClick={() => onOpen(row.id)}>
                              <img
                                src={assest.tableview}
                                width={16}
                                height={16}
                                alt=""
                              />
                            </Button>
                          </Box>
                          {/* </Link> */}
                        </TableCell>
                      </TableRow>

                      <TableRow className={styles.blnkTd}>
                        <TableCell colSpan={8}>{""}</TableCell>
                      </TableRow>
                    </>
                  ))}
                </>
              ) : (
                <TableRow className={styles.paginationTble}>
                  {month ||
                    year ||
                    manager_id ||
                    published ||
                    unreachable_submitter ||
                    submit_place ? (
                    <TableCell colSpan={8} className={styles1.borderNone}>
                      <Filter resetFilters={props?.filtersReset} />
                    </TableCell>
                  ) : (
                    <>
                      {query || from || to ? (
                        <TableCell colSpan={8} className={styles1.borderNone}>
                          <NoResult heading={"website-only"} query={query} />
                        </TableCell>
                      ) : (
                        <TableCell colSpan={8} className={styles1.borderNone}>
                          <EmptyTable
                            emptyTableText={
                              "You have no videos approved for website-only posting at the moment. Please reload the page or check back later."
                            }
                          />
                        </TableCell>
                      )}
                    </>
                  )}
                </TableRow>
              )}

              <TableRow className={styles.paginationTble}>
                <TableCell colSpan={8} sx={{ border: "none !important" }}>
                  {props?.videos?.total > 0 ? (
                    <>
                      { props?.videos?.total < 20 ? (
                        <div
                          style={{
                            color: "#828282",
                            textAlign: "center",
                            fontSize: "13px",
                            padding: "5px 0px",
                          }}
                        >
                          <p>
                            {query?.length > 0
                              ? "End of list. We couldn't find more videos matching your search."
                              : month ||
                                year ||
                                manager_id ||
                                published ||
                                unreachable_submitter ||
                                submit_place
                                ? "End of list. We couldn't find more videos matching your selected filter(s)."
                                : ""}
                          </p>
                        </div>
                      ) : (
                        <Pagination
                          lastpage={props?.videos?.last_page}
                          onClick={undefined}
                          sendDataToParent={props?.handlePageChange}
                        />
                      )}
                    </>
                  ) : (
                    ""
                  )}
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
        {/* </PerfectScrollbar> */}
        <VideoPageFullModal
          onClose={onClose}
          open={openModal}
          id={id}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
          className="videoPageModal"
        />
        <WatchVideoModal
          onClose={onCloseTwo}
          open={openModalTwo}
          id={id}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
          className="videoPageModal"
        />

      </Box>

      <Dialog className="filterModal" onClose={handleClose} open={open}>
        <DisplayRelease />
      </Dialog>
    </Box>
  );
}
